export default __webpack_public_path__ + "static/media/CountPage2.fb0b6beb.txt";